import { render, staticRenderFns } from "./AssociationDiv.vue?vue&type=template&id=b713d236"
import script from "./AssociationDiv.vue?vue&type=script&lang=js"
export * from "./AssociationDiv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports